export default __webpack_public_path__ + "static/media/person2.838aed8a.jpg";